export const Area = [
    {
        areacode: 'jiangsu',
        name: '省市场',
        tenantCode: 'js_province',
        type: 0
    },
    {
        areacode: 'nanjing',
        name: '南京',
        alias: '南京分中心',
        tenantCode: 'nanjing_sub_center',
        type: 1
    },
    {
        areacode: 'huaian',
        name: '淮安',
        alias: '淮安分中心',
        tenantCode: 'huaian_sub_center',
        type: 1
    },
    {
        areacode: 'xuzhou',
        name: '徐州',
        alias: '徐州分中心',
        tenantCode: 'xuzhou_sub_center',
        type: 1
    },
    {
        areacode: 'nantong',
        name: '南通',
        alias: '南通分中心',
        tenantCode: 'nantong_sub_center',
        type: 1
    },
    {
        areacode: 'wuxi',
        name: '无锡',
        alias: '无锡分中心',
        tenantCode: 'wuxi_sub_center',
        type: 1
    },
    {
        areacode: 'suzhou',
        name: '苏州',
        alias: '苏州分中心',
        tenantCode: 'suzhou_sub_center',
        type: 1
    },
    {
        areacode: 'yangzhou',
        name: '扬州',
        alias: '扬州分中心',
        tenantCode: 'yangzhou_sub_center',
        type: 1
    },
    {
        areacode: 'zhenjiang',
        name: '镇江',
        alias: '镇江分中心',
        tenantCode: 'zhenjiang_sub_center',
        type: 1
    },
    {
        areacode: 'changzhou',
        name: '常州',
        alias: '常州分中心',
        tenantCode: 'changzhou_sub_center',
        type: 1
    },
    {
        areacode: 'lianyungang',
        name: '连云港',
        alias: '连云港分中心',
        tenantCode: 'lianyungang_sub_center',
        type: 1
    },
    {
        areacode: 'jiangyin',
        name: '江阴',
        alias: '江阴分中心',
        tenantCode: 'jiangyin_sub_center',
        type: 1
    },
    // {
    //     areacode: 'jiangbei',
    //     name: '江北新区',
    //     alias: '江北新区分中心',
    //     tenantCode: 'jiangbei_sub_center',
    //     type: 1
    // },
    {
        areacode: 'yancheng',
        name: '盐城',
        alias: '盐城分中心',
        tenantCode: 'yancheng_sub_center',
        type: 1
    },
    // {
    //     areacode: 'taizhou',
    //     name: '泰州',
    //     alias: '泰州分中心',
    //     tenantCode: 'taizhou_sub_center',
    //     type: 1
    // },
    /*
    {
        areacode: 'suqian',
        name: '宿迁',
        alias: '宿迁分中心',
        tenantCode: 'suqian_sub_center',
        type: 1
    },
    */
    {
        areacode: 'wlw',
        name: '物联网',
        alias: '物联网分中心(无锡)',
        tenantCode: 'wlw_sub_center',
        type: 2
    },
    {
        areacode: 'ksaq',
        name: '矿山安全',
        alias: '矿山安全分中心(徐州)',
        tenantCode: 'ksaq_sub_center',
        type: 2
    },
    // {
    //     areacode: 'gnxcl',
    //     name: '功能新材料',
    //     alias: '功能新材料分中心(海安)',
    //     tenantCode: 'gnxcl_sub_center',
    //     type: 2
    // },
    {
        areacode: 'rgzn',
        name: '人工智能',
        alias: '人工智能分中心(苏州)',
        tenantCode: 'rgzn_sub_center',
        type: 2
    },
    // {
    //     areacode: 'gxnhjcl',
    //     name: '高性能合金材料',
    //     alias: '高性能合金材料分中心(丹阳)',
    //     tenantCode: 'gxnhjcl_sub_center',
    //     type: 2
    // },
    {
        areacode: 'jnhb',
        name: '节能环保',
        alias: '节能环保分中心(宜兴)',
        tenantCode: 'jnhb_sub_center',
        type: 2
    },
    {
        areacode: 'qcjhxlbj',
        name: '汽车及核心零部件',
        alias: '汽车及核心零部件分中心(常熟)',
        tenantCode: 'qcjhxlbj_sub_center',
        type: 2
    },
    // {
    //     areacode: 'jqrjznzb',
    //     name: '机器人及智能装备',
    //     alias: '机器人及智能装备分中心(武进)',
    //     tenantCode: 'jqrjznzb_sub_center',
    //     type: 2
    // },
    {
        areacode: 'kunshan',
        name: '机器人及精密装备制造',
        alias: '机器人及精密装备制造分中心(昆山)',
        tenantCode: 'kunshan_sub_center',
        type: 2
    },
    // {
    //     areacode: 'dljcndc',
    //     name: '动力及储能电池',
    //     alias: '动力及储能电池行业分中心(金坛)',
    //     tenantCode: 'dljcndc_sub_center',
    //     type: 2
    // },
    // {
    //     areacode: 'xdny',
    //     name: '现代农业',
    //     alias: '现代农业行业分中心(白马)',
    //     tenantCode: 'xdny_sub_center',
    //     type: 2
    // },
    {
        areacode: 'jsxcl',
        name: '金属新材料',
        alias: '金属新材料分中心(张家港)',
        tenantCode: 'jsxcl_sub_center',
        type: 2
    },
    // {
    //     areacode: 'gdnyzb',
    //     name: '高端能源装备',
    //     alias: '高端能源装备分中心（常州）',
    //     tenantCode: 'gdnyzb_sub_center',
    //     type: 2
    // },
    {
        areacode: 'hykzsxny',
        name: '海洋可再生能源',
        alias: '海洋可再生能源分中心（盐城）',
        tenantCode: 'hykzsxny_sub_center',
        type: 2
    },
    {
        areacode: 'gxjn',
        name: '高效节能',
        alias: '高效节能分中心（镇江）',
        tenantCode: 'gxjn_sub_center',
        type: 2
    },
    {
        areacode: 'wlxxaq',
        name: '网络信息安全',
        alias: '网络信息安全分中心（泰州）',
        tenantCode: 'wlxxaq_sub_center',
        type: 2
    },
    {
        areacode: 'xjfhcl',
        name: '先进复合材料',
        alias: '先进复合材料分中心（宿迁）',
        tenantCode: 'xjfhcl_sub_center',
        type: 2
    }
]

export const PlatformUrl = 'http://www.cs-jstec.net'

export const ZoneList = [
    {
        //     name: '省市场',
        //     url: 'jiangsu'
        // },
        // {
        name: '南京分中心',
        url: 'nanjing'
    },
    {
        name: '苏州分中心',
        url: 'suzhou'
    },
    {
        name: '扬州分中心',
        url: 'yangzhou'
    },
    {
        name: '无锡分中心',
        url: 'wuxi'
    },
    {
        name: '徐州分中心',
        url: 'xuzhou'
    },
    // {
    //     name: '泰州分中心',
    //     url: 'taizhou'
    // },
    {
        name: '盐城分中心',
        url: 'yancheng'
    },
    {
        name: '连云港分中心',
        url: 'lianyungang'
    },
    {
        name: '淮安分中心',
        url: 'huaian'
    },
    {
        name: '镇江分中心',
        url: 'zhenjiang'
    },
    {
        name: '江阴分中心',
        url: 'jiangyin'
    },
    {
        name: '南通分中心',
        url: 'nantong'
    },
    {
        name: '常州分中心',
        url: 'changzhou'
    }
]

export const IndustryList = [
    {
        name: '物联网分中心(无锡)',
        url: 'wlw'
    },
    // {
    //     name: '机器人及智能装备分中心(武进)',
    //     url: 'jqrjznzb'
    // },
    {
        name: '矿山安全分中心(徐州)',
        url: 'ksaq'
    },
    {
        name: '汽车及核心零部件分中心(常熟)',
        url: 'qcjhxlbj'
    },
    {
        name: '节能环保分中心(宜兴)',
        url: 'jnhb'
    },
    // {
    //     name: '高性能合金材料分中心(丹阳)',
    //     url: 'gxnhjcl'
    // },
    {
        name: '人工智能分中心(苏州)',
        url: 'rgzn'
    },
    {
        name: '机器人及精密装备制造分中心(昆山)',
        url: 'kunshan'
    },
    // {
    //     name: '功能新材料分中心(海安)',
    //     url: 'gnxcl'
    // },
    // {
    //     name: '动力及储能电池行业分中心(金坛)',
    //     url: 'dljcndc'
    // },
    // {
    //     name: '现代农业行业分中心(南京白马)',
    //     url: 'xdny'
    // },
    {
        name: '金属新材料分中心(张家港)',
        url: 'jsxcl'
    },
    {
        name: '高端能源装备分中心（常州）',
        url: 'gdnyzb'
    },
    {
        name: '海洋可再生能源分中心（盐城）',
        url: 'hykzsxny'
    },
    {
        name: '高效节能分中心（镇江）',
        url: 'gxjn'
    },
    {
        name: '网络信息安全分中心（泰州）',
        url: 'wlxxaq'
    },
    {
        name: '先进复合材料分中心（宿迁）',
        url: 'xjfhcl'
    }
    // {
    //     name: '江北大健康分中心(南京)',
    //     url: ''
    // }
]

export const QuickList = [
    {
        name: '科技创新券',
        url: 'https://yqgx.jssic.cn/#/cxq/cxq',
        // url: 'kjttest5.develop.lianchuanghj.com:48008/#/index',
        assets: 'cxq.png',
        value: '00'
    },
    {
        name: '身份申请',
        redirect: '/identity',
        assets: 'personcentre.png',
        value: '01'
    },
    {
        name: '店铺中心',
        redirect: '/business',
        assets: 'sellercentre.png',
        value: '02'
    },
    {
        name: '供需发布',
        url: '/supply',
        assets: 'publish.png',
        value: '05'
    },
    {
        name: '在线竞拍',
        url: 'https://bid.jstec.com.cn/',
        assets: 'auction.png',
        value: '07'
    },
    {
        name: '创新挑战',
        url: '/crowdsourcing',
        assets: 'crowdsourcing.png',
        value: '08'
    },
    {
        name: '公示专栏',
        url: '/publicity',
        assets: 'publicity.png',
        value: '09'
    },
    {
        name: '挂牌专栏',
        url: '/listed',
        assets: 'listed.png',
        value: '10'
    }
]

export const ExhibationList = [
    // {
    //     name: '江苏发展大会',
    //     url: 'http://www.cs-jstec.net/fzdh/index',
    //     assets: 'js_icon.png',
    //     rel: 'nofollow'
    // },
    // {
    //     name: '大院大所合作对接会',
    //     url: 'http://jccc.jstec.com.cn',
    //     assets: 'cg_icon.png',
    //     rel: 'nofollow'
    // },
    {
        name: '"创业江苏"科技创业大赛',
        url: 'http://www.jscyds.cn/',
        assets: 'cx_icon.png',
        rel: 'nofollow'
    },
    // {
    //     name: '跨国技术转移大会',
    //     url: 'http://www.cittc.org',
    //     assets: 'gx_icon.png',
    //     rel: 'nofollow'
    // }
]

export const ServiceList = [
    // {
    //     name: '国家知识产权公共服务网',
    //     url: 'http://ggfw.cnipa.gov.cn:8010',
    //     assets: 'fw_icon.png',
    //     rel: 'nofollow'
    // },
    {
        name: '江苏省高新技术企业辅助材料提交系统',
        url: 'http://210.73.128.119/GQSB/SGQ/GJLogin.jsp',
        assets: 'gx_icon.png',
        rel: 'nofollow'
    },
    {
        name: '省高新技术企业培育库入库企业申报信息系统',
        url: 'http://210.73.128.119/GQSB/SGQ/login.jsp',
        assets: 'qy_icon.png',
        rel: 'nofollow'
    },
    {
        name: '江苏省科技企业上市培育计划入库系统',
        url: 'http://210.73.128.119/GQSB/SGQ/SJHLogin.jsp',
        assets: 'py_icon.png',
        rel: 'nofollow'
    }
]
